import { IconProps } from "./types";

/** An arrow out to the top right: go to the page this item belongs to. */
export function ArrowUpRightIcon({ size = 24, className = "", ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M7 17L17 7M9 7h8v8" />
    </svg>
  );
}
